import styled from 'styled-components'

import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import Button, { ButtonSize, ButtonTheme } from 'builder/components/Button'

export const Container = styled.div`
  position: fixed;
  top: 12px;
  right: 65px;
  margin-left: 0;
  z-index: 1;

  display: flex;
  gap: 17px;

  ${Media.Laptop`
    position: unset;
    display: block;
  `}
`

export const BookButton = styled(Button).attrs({
  theme: ButtonTheme.ghost,
  size: ButtonSize.small,
})`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const HorizontalLine = styled.div`
  width: 1px;
  margin: 8px 0;
  background-color: ${Colors.Neutral20};

  ${Media.Laptop`
    display: none;
  `}
`
